import React, { Component } from 'react';
import { ErrorContainer } from '../coursalytics/pages/error_page/error_container';
import { ErrorTitle } from '../coursalytics/pages/error_page/error_title';
import Layout from '../coursalytics/components/Layout/DefaultLayout';
import NewDesignStyles from '../coursalytics/blocks/new_design_styles';

class ErrorPage extends Component {
  render() {
    return (
      <Layout>
        <NewDesignStyles />
        <ErrorContainer>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <ErrorTitle>
                  :-(

                  <br />
                  <br />

                  Page not found
                </ErrorTitle>
              </div>
            </div>
          </div>
        </ErrorContainer>
      </Layout>
    );
  }
}

ErrorPage.propTypes = {};

export default ErrorPage;
